// hooks/useForm.js
import { useState, useEffect } from 'react';
import formService from '../services/formService';

export const useForm = (initialState = {}, formType = 'contact') => {
  const [formData, setFormData] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [prefilledData, setPrefilledData] = useState(null);

  // Pre-fill form with saved cookie data on component mount
  useEffect(() => {
    const savedData = formService.getPrefilledData();
    if (savedData) {
      setPrefilledData(savedData);
      
      // Auto-fill matching fields that are empty
      const updatedFormData = { ...initialState };
      Object.keys(savedData).forEach(key => {
        if (initialState.hasOwnProperty(key) && !formData[key] && savedData[key]) {
          updatedFormData[key] = savedData[key];
        }
      });
      
      setFormData(updatedFormData);
    }
  }, []);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const result = await formService.submitForm(formData, formType);
      return result;
    } catch (error) {
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData(initialState);
  };

  return {
    formData,
    setFormData,
    handleChange,
    handleSubmit,
    isSubmitting,
    resetForm,
    prefilledData
  };
};